<template>
  <!-- <div class="box-overlapCards"> -->
  <div class="detail" @click="submitButton(info)">
    <p>{{ dayjs(info.release_time * 1000).format("YYYY-MM-DD") }}</p>
    <p>
      <el-tag type="primary" v-if="info.column_title">{{ info.column_title }}</el-tag>
      <span> {{ info.title }}</span>
    </p>
    <p class="p3-research">
      {{ info.intro }}
    </p>
    <div>
      <el-tag effect="plain" v-if="byIdGetText(info.classes, 'classes2')">
        {{ byIdGetText(info.classes, "classes2") }}
      </el-tag>
      <el-tag effect="plain" v-if="byIdGetText(info.subject, 'subject')">
        {{ byIdGetText(info.subject, "subject") }}
      </el-tag>
      <el-tag effect="plain" v-for="(item, index) in info.tags" :key="index">
        {{ item.name }}</el-tag
      >
      <!-- <el-tag effect="plain"> </el-tag> -->
    </div>
    <!-- <el-button round>查看详情</el-button> -->
  </div>

  <!-- </div> -->
</template>

<script setup>
import { reactive } from "vue";
import { useRouter } from "vue-router";
import dayjs from "dayjs";
import { useIdGetUrl } from "@/utils/slide.js";

const router = useRouter();

const mydata = reactive({
  classes2: JSON.parse(localStorage.getItem("classes2")) ?? [],
  subject: JSON.parse(localStorage.getItem("subject")) ?? [],

  // path: "",
  // // 基础地址
  // VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
});
// console.log(mydata.classes2,"classes2")
// console.log(mydata.subject,"subject")

const props = defineProps({
  path: {
    type: String,
    // default: "",
  },
  info: {
    type: Object,
    default: () => {
      return {};
    },
  },
});

// 通过ID得到对应文字
function byIdGetText(id, key) {
  return mydata[key].find((item) => String(item.name) === String(id))?.label;
}

//按钮点击事件
function submitButton(info) {
  // let obj = {
  //   26: "/layout/list/KnowledgeDetails", // 知识干货
  //   27: "/layout/list/onlineDetails", // 在线学习
  //   28: "/layout/list/thematicDetails", // 专题活动
  //   29: "/layout/list/worksDisplayDetails", // 作品展示
  // };

  // router.push({
  //   path: obj[info.column_id],
  //   query: { id: info.id },
  // });
  router.push({
    path:"/layout/list/checkTheProcessDetails",
    query: { id: info.id },
  });
}
</script>

<style scoped lang="scss">
// .box-overlapCards {
//   width: 1200px;
//   // height: 407px;
//   // position: relative;
//   margin: 0 auto;
//   border: 1px solid yellow;
.detail {
  width: 343px;
  // height: 192px;
  // border:1px solid rgb(68, 0, 255);
  border-radius: 8px;
  background-color: #ffffff;
  //  box-shadow:2px 2px 3px 2px #c5cbce33;
  // box-shadow: 0px 5px 40px 0px rgba(0, 0, 0, 0.0509803922);
  // box-shadow: 0px 5px 40px 0px #0000000d;
  // position: absolute;
  // top: 173px;
  // margin: 0 auto;
  // left: 0;
  // right: 0;
  padding: 16px 16px 11px 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  cursor: pointer;
  p:nth-of-type(1) {
    height: 22px;
    font-size: 12px;
    font-weight: 400;
    color: #666666;
    margin-bottom: 16px;
  }
  p:nth-of-type(2) {
    width:311px !important;
    min-height: 24px;
    line-height: 24px;

    font-size: 16px;
    font-weight: 700;
    color: #333333;
    margin-bottom: 12px;

    display: flex;
    align-items: center;
    display:block;
    white-space: nowrap; //不折行
    text-overflow: ellipsis !important; //文本溢出 用省略号显示
    overflow: hidden;
    // display: -webkit-box;
    // -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
    // text-overflow: ellipsis; //文本溢出 用省略号显示
    // -webkit-line-clamp: 1; //几行
    // overflow: hidden;

    // border: 1px solid red;

    cursor: pointer;

    :deep(.el-tag.el-tag--primary.el-tag--light) {
      height: 30px;
      font-size: 16px;
      color: rgb(0, 115, 192);
      letter-spacing: 1px;
      margin-right: 8px;
    }
  }
  p:nth-of-type(3) {
    min-height: 22px;
    width: 311px !important;
    line-height: 22px;
    
    display:block;
    display: -webkit-box;
    -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
    text-overflow: ellipsis; //文本溢出 用省略号显示
    -webkit-line-clamp: 2; //几行
    overflow: hidden;

    font-size: 14px;
    font-weight: 400;
    color: #666666;
    margin-bottom: 16px;
    //   border: 1px solid red;

    cursor: pointer;
  }

  p:nth-of-type(2):hover,
  p:nth-of-type(3):hover {
    color: #009de0;
  }
  :deep(.el-tag.el-tag--primary.el-tag--plain) {
    border: 1px solid #c5cbce;
    background-color: #f0f5ff;
    margin-right:5px;
    margin-bottom:5px;
    // margin-bottom: 24px;
    
    .el-tag__content {
      font-size: 12px;
      font-weight: 400;
      color: #333333;
      // color:red;
    }
  }

  
  // :deep(.el-button.is-round) {
  //   border: 1px solid #dcdee2;
  //   width: 120px;
  //   height: 30px;
  //   border-radius: 30px;
  //   background-color: transparent;
  //   span {
  //     font-size: 14px;
  //     font-weight: 400;
  //     color: #999999;
  //   }
  // }
}

.detail:hover {
  > p:nth-of-type(2) {
    color: #009de0;
  }
}
</style>
